import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { NotificationsPage } from '@/features/admin/activity/notifications-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Entrée « Activité » de la navigation : la page complète des notifications (porting README #89). */
export const Route = createFileRoute('/$tenant/notifications')({ component: NotificationsRoute });

function NotificationsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="activity" crumbs={[{ label: t('nav.items.activity') }]}>
      <NotificationsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
